const gamesContent = `
<div style="margin: 20px 0;">
  <h3>Available Games:</h3>
  <p style="margin: 10px 0;">
    <span class="command-link" data-command="thebackdooms" style="color: #5abb9a;">[backdooms]</span> - Play The Backdooms<br>
    <span class="command-link" data-command="snake" style="color: #5abb9a;">[snake]</span> - Play Snake Game<br>
    <span class="command-link" data-command="tetris" style="color: #5abb9a;">[tetris]</span> - Play Tetris Game<br>
    <span class="command-link" data-command="2048" style="color: #5abb9a;">[2048]</span> - Play 2048 Game<br>
    <span class="command-link" data-command="flappybird" style="color: #5abb9a;">[flappybird]</span> - Play Flappy Bird Game<br>
    <span class="command-link" data-command="gameoflife" style="color: #5abb9a;">[gameoflife]</span> - Play Kuber's Game of Life<br>
  </p>
</div>`;

export default gamesContent;